module.exports = __webpack_public_path__ + "img/title.1c7c4029.png";